import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom'

import Navbar from '../components/navbar_poc'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer';
import SEO from '../components/seo'
import bg from '../assets/images/bg.jpg'

import { contactData } from '../data/data'

import Modal from 'react-bootstrap/Modal';
import emailjs from '@emailjs/browser';
import axios from 'axios'
export default function Contact() {
  const [show, setShow] = useState(false);
  const form = useRef();
  const navigate = useNavigate();
  const sendEmail = async (e) => {
    e.preventDefault(); // prevent page reload

    const formData = new FormData(form.current);

    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      subject: formData.get('subject'),
      comments: formData.get('comments'),
    };

    try {
      await axios.post('https://szujfbxbqa.execute-api.us-west-2.amazonaws.com/dev/sesemailpython', data);
      alert('Thank you for your message. We will get in touch with you shortly.');
          // Redirect to home page
    navigate('/');
    } catch (error) {
      console.error('Failed to send email:', error);
      alert('Failed to send message. Please try again.');
    }
  };
  return (
    <>
     <Navbar/> 
     <SEO
  title="Contact Pioneer One Global – Start Your India Journey Today"
  description="Let’s talk about your India plans. Book a consultation or drop us a line — we’re here to guide your next chapter in India."
  url="https://www.pioneeroneglobal.com/contact"
  image="https://www.pioneeroneglobal.com/images/og-contact.jpg"
/>
     <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center'}}>
        <div className="bg-overlay bg-overlay-white"></div>
        <div className="container">
            <div className="row mt-5 text-center align-items-center">
                <div className="col-sm-6">
                    <div className="text-sm-start">
                        <div className="page-next-level">
                            <h4 className="title">Contact Us</h4>
                            <p className="text-muted mb-0">Let's start a conversation!</p>
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="page-next-level text-sm-end">
                        <ul className="page-next ps-0 mb-0">
                            <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                            <li className="list-inline-item"><span className="text-uppercase text-primary fw-bold">Contact</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> 
    </section>

    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Ready to Explore, Enter, or Grow in India?</h4>
                      <p className="text-muted para-desc mx-auto mb-0">If you're a company considering India — whether you're just starting to explore, getting ready to enter, or looking to scale — we’d be delighted to meet. Book a Calendly meeting and let’s talk.</p>
                  </div>
              </div>
          </div>
          {/* <div className="col-sm-5 mt-4 mt-sm-0">
                                <div className="text-sm-end">
                                    <Link to="https://calendly.com/pioneeroneglobal/30min" className="btn btn-primary"><i className="mdi mdi-phone-outline"></i> Book a meeting</Link>
                                </div>
                            </div> */}

<div className="col-12 mt-4 d-flex justify-content-center">
  <Link to="https://calendly.com/pioneeroneglobal/30min" className="btn btn-primary">
    <i className="mdi mdi-phone-outline"></i> Book a meeting
  </Link>
</div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Not quite there yet?</h4>
                      <p className="text-muted para-desc mx-auto mb-0">If you have a quick question, idea, or simply want to say hello, feel free to use the contact form below.</p>
                  </div>
              </div>
          </div>
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">A small request</h4>
                      <p className="text-muted para-desc mx-auto mb-0">To keep our calendars open for meaningful conversations, we kindly ask that service providers, job seekers, and sales teams use the contact form rather than booking a meeting. We appreciate your understanding!</p>
                  </div>
              </div>
          </div>

          <div className="row justify-content-center">
              <div className="col-md-8 mt-4 pt-2">
                  <div className="custom-form">
                      <form ref={form} onSubmit={sendEmail}>
                          <div className="row">
                              <div className="col-md-6">
                                  <div className="mb-3">
                                      <label className="form-label">Your Name <span className="text-danger">*</span></label>
                                      <input name="name" id="name" type="text" className="form-control" placeholder="Name :"/>
                                  </div>
                              </div>

                              <div className="col-md-6">
                                  <div className="mb-3">
                                      <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                      <input name="email" id="email" type="email" className="form-control" placeholder="Email :"/>
                                  </div>
                              </div>

                              <div className="col-12">
                                  <div className="mb-3">
                                      <label className="form-label">Subject</label>
                                      <input name="subject" id="subject" className="form-control" placeholder="subject :"/>
                                  </div>
                              </div>

                              <div className="col-12">
                                  <div className="mb-3">
                                      <label className="form-label">Comments <span className="text-danger">*</span></label>
                                      <textarea name="comments" id="comments" rows="4" className="form-control" placeholder="Message :"></textarea>
                                  </div>
                              </div>
                          </div>
                          <div className="row">
                              <div className="col-12">
                                  <div className="d-grid">
                                      <button type="submit" id="submit" name="send" className="btn btn-primary">Send Message</button>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>

      <Modal show={show} onHide={()=>setShow(!show)} size='lg'>
        <Modal.Body>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39206.002432144705!2d-95.4973981212445!3d29.709510002925988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c16de81f3ca5%3A0xf43e0b60ae539ac9!2sGerald+D.+Hines+Waterwall+Park!5e0!3m2!1sen!2sin!4v1566305861440!5m2!1sen!2sin" title='map' data-type="iframe" className="video-play-icon lightbox h6 text-white w-100" frameBorder="0" ></iframe>
        </Modal.Body>
      </Modal>
    </>
  )
}
